// 业务路由
export default [
  {
    path: "/",
    component: () => import("@/views/homePage/index"),
  },
  {
    path: "/openList",
    component: () => import("@/views/openConfig/openList"),
  },
  {
    path: "/nameList",
    component: () => import("@/views/openConfig/nameList"),
  },
  {
    path: "/floorPlan",
    component: () => import("@/views/floorPlan/testIndex"),
  },
  {
    path: "/alarmConfig",
    component: () => import("@/views/openConfig/alarmConfig"),
  },
  {
    path: "/projectConfig",
    component: () => import("@/views/projectConfig/projectConfig"),
  },
  {
    path: "/audioPackage",
    component: () => import("@/views/audioPackage/index"),
  },
  {
    path: "/elevatorControl",
    component: () => import("@/views/elevatorControl/index"),
  },
];
